import React from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
import { Card, CardContent } from '@components/ui/card';
import {
    Collapsible,
    CollapsibleContent,
    CollapsibleTrigger
} from '@components/ui/collapsible';
import { Checkbox } from '@components/checkbox';

export const REQUIRED_PROFILE_FIELDS_QUERY_PARAMETER = 'rp';

export const REQUIRED_PROFILE_FIELDS = [
    { code: 'g', label: 'Gender' },
    { code: 'd', label: 'Date of birth' },
    { code: 'b', label: 'Bio' }
];

export interface RequiredProfileFieldsProps {
    selected: string[];
    onChange: (selected: string[]) => void;
}

export const RequiredProfileFields: React.FC<RequiredProfileFieldsProps> = ({
    selected,
    onChange
}) => {
    const [expanded, setExpanded] = React.useState(false);

    const summary = REQUIRED_PROFILE_FIELDS.filter((field) =>
        selected.includes(field.code)
    )
        .map((field) => field.label)
        .join(', ');

    const toggle = (code: string, checked: boolean) =>
        onChange(
            checked
                ? [...selected, code]
                : selected.filter((selectedCode) => selectedCode !== code)
        );

    return (
        <Card>
            <Collapsible open={expanded} onOpenChange={setExpanded}>
                <CollapsibleTrigger className="flex w-full items-center justify-between px-6 py-4 text-left">
                    <span className="flex flex-col gap-0.5">
                        <span className="text-sm font-medium">
                            Required Profile Fields
                        </span>
                        {!expanded && summary && (
                            <span className="text-xs text-muted-foreground">
                                {summary}
                            </span>
                        )}
                    </span>
                    {expanded ? (
                        <ChevronUp className="size-4 text-muted-foreground" />
                    ) : (
                        <ChevronDown className="size-4 text-muted-foreground" />
                    )}
                </CollapsibleTrigger>
                <CollapsibleContent>
                    <CardContent className="flex flex-col gap-3 pt-0">
                        <p className="text-sm text-muted-foreground">
                            The app asks for these before onboarding continues
                        </p>
                        {REQUIRED_PROFILE_FIELDS.map((field) => (
                            <Checkbox
                                key={field.code}
                                center
                                checked={selected.includes(field.code)}
                                onChange={(event) =>
                                    toggle(field.code, event.target.checked)
                                }
                            >
                                {field.label}
                            </Checkbox>
                        ))}
                    </CardContent>
                </CollapsibleContent>
            </Collapsible>
        </Card>
    );
};
